var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".15vw",
    height: "0.5vw",
    viewBox: "0 0 3 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.916 3.39565L0.167946 3.71124L0.069544 4.1291L0.609554 4.22037C0.962361 4.29734 1.03196 4.4139 0.955161 4.73609L0.069544 8.54959C-0.163261 9.53596 0.195547 10 1.03916 10C1.69318 10 2.45279 9.72289 2.7972 9.34242L2.9028 8.88498C2.66279 9.07851 2.31239 9.15549 2.07958 9.15549C1.74958 9.15549 1.62957 8.94326 1.71478 8.56939L2.916 3.39565ZM3 1.09963C3 1.39127 2.87357 1.67096 2.64852 1.87718C2.42347 2.0834 2.11824 2.19925 1.79998 2.19925C1.48171 2.19925 1.17648 2.0834 0.951433 1.87718C0.726385 1.67096 0.599954 1.39127 0.599954 1.09963C0.599954 0.807987 0.726385 0.528293 0.951433 0.322073C1.17648 0.115853 1.48171 0 1.79998 0C2.11824 0 2.42347 0.115853 2.64852 0.322073C2.87357 0.528293 3 0.807987 3 1.09963Z",
    fill: "#E77B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedInfo);
export default __webpack_public_path__ + "static/media/redInfo.7a0fd0e93e25f29ef8b393edb6247038.svg";
export { ForwardRef as ReactComponent };